import Axios from "axios";
import { action, decorate, observable } from "mobx";
import LocalGridConfig from "../../../../config/LocalGridConfig";

export default class ManageRelaxNotBookedConsignmentStore {
    agGrid = null;
    per_page = LocalGridConfig.options.paginationPageSize;
    current_page = 1;
    list_data = null;
    editValues = null;
    deleteValues = null;
    total = 0;
    allColumnIds = [];

    setEditValues = data => {
        this.editValues = data;
    };
    setDeleteValues = data => {
        this.deleteValues = data;
    };
    setupGrid = params => {
        this.agGrid = params;
    };

    setPageSize = (page = this.per_page) => {
        this.per_page = page;
        if (this.agGrid) {
            this.agGrid.api.paginationSetPageSize(parseInt(page));
        }
    };

    onFilterChanged = params => {
        this.agGrid = params;
        if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
            this.agGrid.api.showNoRowsOverlay();
        }
        if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
            this.agGrid.api.hideOverlay();
        }
    };

    /**
     * List — pass is_purpose: 1 (by location) or 2 (by hub)
     */
    getList = isPurpose => {
        if (this.agGrid) {
            var filter = this.agGrid.api.getFilterModel();
            var sort = this.agGrid.api.getSortModel();
        }
        this.list_data = null;
        return Axios.post(`/locks/relax-not-booked-consignment/list`, { is_purpose: isPurpose }).then(({ data }) => {
            if (data.list.data.length) {
                data.list.data.map((item, index) => {
                    item.srno = index + 1;
                    return null;
                });
            }
            this.list_data = data.list?.data ? data.list.data : null;
            this.total = data.list.total;
            this.current_page = data.list.current_page;
            if (this.agGrid) {
                this.agGrid.api.setFilterModel(filter);
                this.agGrid.api.setSortModel(sort);
            }
        });
    };

    /**
     * Add — pass is_purpose in formData
     */
    AddData = formData => {
        return Axios.post(`/locks/relax-not-booked-consignment/new`, formData)
            .then(({ data }) => {
                this.getList(formData.is_purpose);
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) notify = NOTIFICATION[0];
                    Object.keys(fieldErrors).forEach(name => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };

    /**
     * Edit — pass is_purpose in formData (used to refresh correct list after save)
     */
    EditData = formData => {
        return Axios.post(`/locks/relax-not-booked-consignment/edit/` + formData.id, formData)
            .then(({ data }) => {
                this.getList(formData.is_purpose);
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) notify = NOTIFICATION[0];
                    Object.keys(fieldErrors).forEach(name => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };

    /**
     * Delete — no is_purpose needed
     */
    DeleteData = (id, isPurpose) => {
        return Axios.delete(`/locks/relax-not-booked-consignment/destroy/` + id)
            .then(({ data }) => {
                this.getList(isPurpose);
                return data;
            })
            .catch(response => Promise.reject(response));
    };
}

decorate(ManageRelaxNotBookedConsignmentStore, {
    per_page: observable,
    agGrid: observable,
    list_data: observable,
    editValues: observable,
    deleteValues: observable,
    total: observable,
    allColumnIds: observable,
    setupGrid: action,
    setPageSize: action,
    setEditValues: action,
    setDeleteValues: action,
    getList: action,
    onFilterChanged: action,
});
